import React, { useContext, useEffect, useRef, useState } from "react";

import makeStyles from "@mui/styles/makeStyles";
import LanguageContext from "../LanguageContext";
import UserService from "../services/UserService";
import {
  Close,
  ExpandLess,
  ExpandMore,
  ThumbUp,
  ThumbUpOutlined,
  Visibility,
} from "@mui/icons-material";
import _ from "lodash";
import { useHistory, useLocation, useParams } from "react-router-dom";

import firebase from "../firebase";
import ErrorBoundary from "./ErrorBoundry";
import ReactVideoPlayer from "./ReactVideoPlayer";
import VideosService from "../services/VideosService";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import config from "../config";
import Typography from "@mui/material/Typography";
import messages from "../services/messages";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
} from "@mui/material";
import Container from "@mui/material/Container";
import { WhatsappShareButton } from "react-share";
import { Navigation, Virtual } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css/bundle";

import Button from "@mui/material/Button";
// import Bowser from "bowser";
import content from "../services/content";
import ProductService from "../services/ProductService";

// const browser = Bowser.getParser(window.navigator.userAgent);

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#000000",
    height: window.innerHeight,
    // flexGrow: "1",
  },
  avatar: {
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
  // ytPlayerContainer: {
  //   // marginTop: theme.spacing(3),
  //   height: "45vh",
  // },
  ytDialog: {
    background: "#000000",
  },
  ytPlayer: {
    // height: "100vh",
    // alignItems: "center",
    // justifyContent: "center",
    // marginTop:theme.spacing(2),
    backgroundColor: "black",
  },
  closeButtonContainer: {},
  ytPlayerClose: {},
  ytPlayerCloseIcon: {
    cursor: "pointer",
    fontSize: theme.spacing(3),
    backgroundColor: "transparent",
    color: "white ",
  },
  swiperContainer: {
    height: "1280px",
    maxHeight: window.innerHeight,
    overscrollBehavior: "contain",
  },
  swiperSlide: {
    background: "#000000",
    // height: "640px",
  },
  videoMetadata: {
    marginTop: "-47vh",
  },
  videoMetadataShared: {},

  titleContainer: {
    // marginTop: theme.spacing(-2.5),
  },
  authorContainer: {
    marginTop: theme.spacing(0.2),
  },
  skusContainer: {
    marginTop: theme.spacing(0),
  },
  skuImage: {
    marginBottom: theme.spacing(-0.9),
  },
  skuClickHere: {
    fontSize: "12px",
    height: 18,
    padding: -1,
    marginBottom: theme.spacing(-1.2),
    borderRadius: "0",
  },
  viewsContainer: {
    marginTop: theme.spacing(0),
  },
  nextButtonContainer: {
    marginTop: theme.spacing(0.5),
    // position: "fixed",
    // top: window.innerHeight - 40,
    // bottom:
    //   browser.getBrowserName() === "Chrome"
    //     ? navigator.userAgent.includes("wv")
    //       ? theme.spacing(2)
    //       : theme.spacing(8)
    //     : theme.spacing(2),
    background: "#000000",
  },
  nextButton: {
    marginLeft: theme.spacing(-1),
    // marginRight: theme.spacing(-2),
    color: "#FFFFFF",
    borderColor: "#CCCCCC",
    background: "#212121",
    fontSize: theme.spacing(1.5),
    "&:hover": {
      color: "#FFFFFF",
      background: "#212121",
    },
    "&:disabled": {
      background: "#212121",
      color: "#F1F1F1",
      opacity: "0.3",
    },
  },
  verticalRule: {
    borderLeft: "1px solid #CCCCCC",
    height: theme.spacing(1.4),
    marginBottom: theme.spacing(1.5),
    marginLeft: theme.spacing(-1.3),
  },
  previousButton: {
    // marginLeft: theme.spacing(-5.9),
    color: "#FFFFFF",
    borderColor: "#CCCCCC",
    background: "#212121",
    fontSize: theme.spacing(1.5),
    "&:hover": {
      color: "#FFFFFF",
      background: "#212121",
    },
    "&:disabled": {
      background: "#212121",
      color: "#F1F1F1",
      opacity: "0.3",
    },
  },

  contentVideoTitle: {
    fontWeight: 600,
    color: "#FFFFFF",
    // fontSize:"14px",
    // marginTop: theme.spacing(1),
  },
  authorName: {
    marginLeft: theme.spacing(-0.5),
    fontSize: "12px",
    color: "#FFFFFF",
  },
  skuCard: {
    marginTop: theme.spacing(-1),
    backgroundColor: "#000000",
    cursor: "pointer",
  },
  skusTitle: {
    marginTop: theme.spacing(1),
    fontSize: "14px",
    color: "#FFFFFF",
  },
  skuCardContent: {
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(-2),
  },
  viewsIconContainer: {
    marginBottom: theme.spacing(-0.5),
    marginTop: theme.spacing(-0.6),
    // marginLeft: theme.spacing(-1),
  },
  viewsIcon: {
    color: "#FFFFFF",
    height: theme.spacing(2.5),
    opacity: "0.6",
    // marginTop: theme.spacing(-1),
    // marginLeft: theme.spacing(-1),
  },
  viewsCount: {
    color: "#FFFFFF",
    opacity: "0.6",
    // marginTop: theme.spacing(-1),
  },
  newTagContainer: {
    marginBottom: theme.spacing(0.8),
    marginTop: theme.spacing(0.2),
    marginLeft: theme.spacing(0.1),
    paddingLeft: theme.spacing(0.3),
    paddingRight: theme.spacing(0.3),
    paddingBottom: theme.spacing(0),
    paddingTop: theme.spacing(0.2),
    borderRadius: theme.spacing(0.3),
    color: "#FFFFFF",
    height: theme.spacing(2.5),
    background: "#ef5350",
  },
  newTag: {},
  socialActionContainer: {
    // marginTop: "-1vh",
    // position: "fixed",
    // bottom: "7vh",
    // right: "4vw",
  },
  shareIconContainer: {
    // marginLeft: theme.spacing(-0.5),
    marginTop: theme.spacing(-1),
  },
  shareIcon: {
    color: "#FFFFFF",
    // padding: theme.spacing(-0.5),
    // marginTop: theme.spacing(0.5),
    height: theme.spacing(4),
  },
  sharesCountContainer: {
    marginTop: theme.spacing(-1),
    color: "#FFFFFF",
  },
  sharesCount: {
    marginLeft: theme.spacing(-2.3),
  },
  likeButton: {
    color: "#FFFFFF",
    marginTop: theme.spacing(-0.5),
    // height: theme.spacing(1),
  },
  likeIcon: {
    color: "#FFFFFF",
    // marginTop: theme.spacing(-1),
    height: theme.spacing(4),
  },
  unlikeIcon: {
    color: "#FFFFFF",
    // marginTop: theme.spacing(-1),
    height: theme.spacing(4),
  },
  likesCountContainer: {
    marginTop: theme.spacing(-2),
    color: "#FFFFFF",
  },
  likesCount: {
    marginLeft: theme.spacing(-2.3),
  },
  playerWrapper: {
    height: "100%",
    width: "100%",
    overflow: "hidden",
    marginTop: theme.spacing(-2.2),
    // marginBottom: theme.spacing(-2.2),
  },
}));

function YoutubeDialog(props) {
  const classes = useStyles();
  let history = useHistory();
  const location = useLocation();
  const [products, setProducts] = useState(null);
  const [swiper, setSwiper] = useState(null);
  // const slideTo = (index) => swiper.slideTo(index);
  const cropNameObjFromRoute = useParams("crop");
  const cropNameFromRoute = cropNameObjFromRoute.crop;
  const youtubeIdObjFromRoute = useParams("youtube_id");
  const youtubeIdFromRoute = youtubeIdObjFromRoute.youtube_id;

  let [contentVideoCurrent, setContentVideoCurrent] = useState(null);
  let [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const language = location?.state?.userLanguage
    ? location.state.userLanguage
    : "mr";
  let { mobile } = UserService.getUserInfo();

  useEffect(() => {
    // setProducts(null);
    // console.log(`active slide change ${activeSlideIndex}`)
    if (location && location.state && location.state.contentVideos) {
      // console.log("has contentvideos");
      let contentVideo = location.state.contentVideos[activeSlideIndex];
      setContentVideoCurrent(contentVideo);

      if (contentVideo.skus && contentVideo.skus.length > 0) {
        let skusToFetch = contentVideo.skus.join(",");

        // ProductService.getProductsListBySKUs(skusToFetch)
        //   .then((response) => {
        //     if (response?.data?.responseData?.productGists?.length > 0) {
        //       let productsFromResponse =
        //         response.data.responseData.productGists;
        //       setProducts(productsFromResponse);
        //     } else {
        //       console.log(`no response received in responseData`);
        //     }
        //   })
        //   .catch((error) => {
        //     console.log(`error getting products`);
        //     if (error.data) {
        //       console.log(error.data);
        //     } else {
        //       console.log(error);
        //     }
        //   });
      }
      firebase.analytics().logEvent("content_video_page_viewed", {
        mobile,
        flow: "from-crop-page",
        crop_name: contentVideo.cropData.name_en,
        author_name: contentVideo.authorData.name_en,
        title: contentVideo.title,
        weeks_after_sowing: contentVideo.weeks_after_sowing,
        stage: contentVideo.stageData.name_en,
        crop_age: contentVideo.crop_age,
        state: contentVideo.stateData.name_en,
        position: location.state.position,
        user_type: location.state.userType,
        users_source: location.state.userSource,
        farmer_crops: JSON.stringify(location.state.farmerCrops),
        crop_segment: contentVideo.crop_segment,
        youtube_id: youtubeIdFromRoute,
        skus: contentVideo.skus,
      });
    } else {
      firebase.analytics().logEvent("content_video_page_viewed", {
        flow: "shared-url",
        youtube_id: youtubeIdFromRoute,
        crop_name: cropNameFromRoute,
      });
    }
  }, [activeSlideIndex]);
  const getShareText = () => {
    let shareText = `${contentVideoCurrent.cropName} ${messages["cropPage.contentVideo.shareText"][language]} https://${window.location.hostname}/crop/${cropNameFromRoute}/content/${contentVideoCurrent.youtube_id} ${messages["cropPage.contentVideo.agrostarAppShareText"][language]}`;
    if (contentVideoCurrent?.cropData?.name_en === "Weather") {
      shareText = `${contentVideoCurrent.cropName} ${messages["cropPage.contentVideo.shareText"][language]} https://${window.location.hostname}/crop/${cropNameFromRoute}/content/${contentVideoCurrent.youtube_id} ${messages["cropPage.contentVideo.agrostarAppShareText"][language]}`;
    }
    return shareText;
  };
  const share = async (event) => {
    event.stopPropagation();

    const { mobile } = UserService.getUserInfo();

    firebase.analytics().logEvent("content_video_shared_on_whatsapp", {
      mobile,
      crop_name: contentVideoCurrent.cropData.name_en,
      author_name: contentVideoCurrent.authorData.name_en,
      title: contentVideoCurrent.title,
      weeks_after_sowing: contentVideoCurrent.weeks_after_sowing,
      stage: contentVideoCurrent.stageData.name_en,
      state: contentVideoCurrent.stateData.name_en,
      position: location.state.position,
      user_type: props.userType,
      crop_segment: contentVideoCurrent.crop_segment,
      user_source: props?.userSource,
      page_name: window.location.pathname,
      skus: contentVideoCurrent.skus,
    });

    let newSharesCount = contentVideoCurrent.shares_count
      ? contentVideoCurrent.shares_count + 1
      : 1;

    setContentVideoCurrent({
      ...contentVideoCurrent,
      shares_count: newSharesCount,
    });

    if (contentVideoCurrent && contentVideoCurrent !== undefined) {
      VideosService.logVideoActivity(contentVideoCurrent.youtube_id, "shared")
        .then(() => {})
        .catch(() => {});
    }
  };

  const likeAVideo = (event) => {
    event.stopPropagation();
    const mobile = location.state.mobile;

    VideosService.logVideoActivity(
      contentVideoCurrent.youtube_id,
      "liked",
      mobile
    )
      .then(() => {})
      .catch(() => {});

    let newLikes = contentVideoCurrent.likes
      ? contentVideoCurrent.likes + 1
      : 1;

    location.state.contentVideos[activeSlideIndex].likes = newLikes;
    setContentVideoCurrent({
      ...contentVideoCurrent,
      likes: newLikes,
      likedByMe: true,
    });

    firebase.analytics().logEvent("content_video_liked", {
      crop_name: contentVideoCurrent.cropData.name_en,
      author_name: contentVideoCurrent.authorData.name_en,
      title: contentVideoCurrent.title,
      weeks_after_sowing: contentVideoCurrent.weeks_after_sowing,
      stage: contentVideoCurrent.stageData.name_en,
      crop_age: contentVideoCurrent.crop_age,
      state: contentVideoCurrent.stateData.name_en,
      position: location.state.position,
      user_type: location.state.userType,
      farmer_crops: JSON.stringify(location.state.farmerCrops),
      crop_segment: contentVideoCurrent.crop_segment,
      youtube_id: contentVideoCurrent.youtube_id,
      user_source: location.state.userSource,
      page_name: window.location.pathname,
      skus: contentVideoCurrent.skus,
    });
  };

  const unlikeAVideo = (event) => {
    event.stopPropagation();

    VideosService.logVideoActivity(
      contentVideoCurrent.youtube_id,
      "unliked",
      location.state.mobile
    )
      .then(() => {})
      .catch(() => {});

    let newLikes = contentVideoCurrent.likes
      ? contentVideoCurrent.likes - 1
      : 0;

    console.log({ newLikes });

    setContentVideoCurrent({
      ...contentVideoCurrent,
      likes: newLikes,
      likedByMe: false,
    });

    firebase.analytics().logEvent("content_video_unliked", {
      crop_name: contentVideoCurrent.cropData.name_en,
      author_name: contentVideoCurrent.authorData.name_en,
      title: contentVideoCurrent.title,
      weeks_after_sowing: contentVideoCurrent.weeks_after_sowing,
      stage: contentVideoCurrent.stageData.name_en,
      crop_age: contentVideoCurrent.crop_age,
      state: contentVideoCurrent.stateData.name_en,
      position: location.state.position,
      user_type: location.state.userType,
      farmer_crops: JSON.stringify(location.state.farmerCrops),
      crop_segment: contentVideoCurrent.crop_segment,
      youtube_id: contentVideoCurrent.youtube_id,
      user_source: location.state.userSource,
      page_name: window.location.pathname,
      skus: contentVideoCurrent.skus,
    });
  };

  const getContentVideoFromYoutubeURL = (videoUrl) => {
    let youtubeId = "";

    let contentVideo = null;

    if (videoUrl) {
      youtubeId = videoUrl.split("v=").pop();
    } else {
      return null;
    }
    return _.filter(location.state.contentVideos, (contentVideo) => {
      return contentVideo.youtube_id === youtubeId;
    })?.[0];
  };

  const contentVideoRetriever = _.memoize(getContentVideoFromYoutubeURL);

  const handlePlaybackStart = (videoUrl, duration) => {
    if (
      videoUrl &&
      videoUrl !== "" &&
      location &&
      location.state &&
      location.state.contentVideo &&
      location.state.contentVideos &&
      location.state.contentVideos.length > 0
    ) {
      let contentVideo = location.state.contentVideo;

      let contentVideoFromId = contentVideoRetriever(videoUrl);

      setContentVideoCurrent(contentVideoFromId);
      if (contentVideoFromId) {
        VideosService.logVideoActivity(contentVideoFromId.youtube_id, "viewed")
          .then((responseLog) => {})
          .catch((error) => {
            console.log(error?.data);
          });
        firebase.analytics().logEvent("content_video_playback_started", {
          flow: "from-crop-page",
          crop_name: contentVideoFromId.cropData.name_en,
          author_name: contentVideoFromId.authorData.name_en,
          title: contentVideoFromId.title,
          weeks_after_sowing: contentVideoFromId.weeks_after_sowing,
          stage: contentVideoFromId.stageData.name_en,
          crop_age: contentVideoFromId.crop_age,
          state: contentVideoFromId.stateData.name_en,
          position: location.state.position,
          user_type: location.state.userType,
          farmer_crops: JSON.stringify(location.state.farmerCrops),
          crop_segment: contentVideoFromId.crop_segment,
          youtube_id: contentVideoFromId.youtube_id,
          user_source: location.state.userSource,
          total_duration: duration,
          skus: contentVideoFromId.skus,
        });
      } else {
        firebase.analytics().logEvent("content_video_playback_started", {
          mobile,
          flow: "shared-url",
          youtube_id: youtubeIdFromRoute,
          crop_name: cropNameFromRoute,
          duration: 60,
          total_duration: duration,
        });
      }
    }
  };
  const handlePlaybackEnd = (videoUrl, duration) => {
    if (
      videoUrl &&
      location &&
      location.state &&
      location.state.contentVideo &&
      location.state.contentVideos &&
      location.state.contentVideos.length > 0
    ) {
      let contentVideo = location.state.contentVideo;

      let contentVideoFromId = contentVideoRetriever(videoUrl);

      swiper.slideTo(activeSlideIndex + 1);
      firebase.analytics().logEvent("content_video_playback_ended", {
        flow: "from-crop-page",
        crop_name: contentVideoFromId.cropData.name_en,
        author_name: contentVideoFromId.authorData.name_en,
        title: contentVideoFromId.title,
        weeks_after_sowing: contentVideoFromId.weeks_after_sowing,
        stage: contentVideoFromId.stageData.name_en,
        crop_age: contentVideoFromId.crop_age,
        state: contentVideoFromId.stateData.name_en,
        position: location.state.position,
        user_type: location.state.userType,
        farmer_crops: JSON.stringify(location.state.farmerCrops),
        crop_segment: contentVideoFromId.crop_segment,
        youtube_id: contentVideoFromId.youtube_id,
        user_source: location.state.userSource,
        total_duration: duration,
        skus: contentVideoFromId.skus,
      });
    } else {
      firebase.analytics().logEvent("content_video_playback_ended", {
        mobile,
        flow: "shared-url",
        youtube_id: youtubeIdFromRoute,
        crop_name: cropNameFromRoute,
        duration: 60,
        total_duration: duration,
      });
    }
  };

  const handlePlaybackProgress = (videoUrl, duration) => {
    if (
      videoUrl &&
      location &&
      location.state &&
      location.state.contentVideo &&
      location.state.contentVideos &&
      location.state.contentVideos.length > 0
    ) {
      let contentVideo = location.state.contentVideo;

      let contentVideoFromId = contentVideoRetriever(videoUrl);

      firebase.analytics().logEvent("content_video_watched", {
        flow: "from-crop-page",
        crop_name: contentVideoFromId.cropData.name_en,
        author_name: contentVideoFromId.authorData.name_en,
        title: contentVideoFromId.title,
        weeks_after_sowing: contentVideoFromId.weeks_after_sowing,
        stage: contentVideoFromId.stageData.name_en,
        crop_age: contentVideoFromId.crop_age,
        state: contentVideoFromId.stateData.name_en,
        position: location.state.position,
        user_type: location.state.userType,
        farmer_crops: JSON.stringify(location.state.farmerCrops),
        crop_segment: contentVideoFromId.crop_segment,
        youtube_id: contentVideoFromId.youtube_id,
        duration: 30,
        user_source: location.state.userSource,
        total_duration: duration,
        skus: contentVideoFromId.skus,
      });
    } else {
      firebase.analytics().logEvent("content_video_watched", {
        mobile,
        flow: "shared-url",
        youtube_id: youtubeIdFromRoute,
        crop_name: cropNameFromRoute,
        duration: 60,
        total_duration: duration,
      });
    }
  };

  const handleClose = () => {
    history.goBack();
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    // e.target.style.display = 'none'
    e.target.src = "/icons/dummy.jpeg";
  };

  return (
    <>
      {location.state &&
      location.state.contentVideos &&
      location.state.contentVideos.length > 0 ? (
        <Swiper
          modules={[Virtual]}
          className={classes.swiperContainer}
          direction={"vertical"}
          spaceBetween={0}
          // slidesPerView={3}
          onSlideChange={(e) => {
            console.log("slide change");
            console.log(e);
            setActiveSlideIndex(e.activeIndex);

            firebase.analytics().logEvent("content_video_swiped", {
              flow: "from-crop-page",
              crop_name: contentVideoCurrent.cropData.name_en,
              author_name: contentVideoCurrent.authorData.name_en,
              title: contentVideoCurrent.title,
              weeks_after_sowing: contentVideoCurrent.weeks_after_sowing,
              stage: contentVideoCurrent.stageData.name_en,
              crop_age: contentVideoCurrent.crop_age,
              state: contentVideoCurrent.stateData.name_en,
              position: location.state.position,
              user_type: location.state.userType,
              farmer_crops: JSON.stringify(location.state.farmerCrops),
              crop_segment: contentVideoCurrent.crop_segment,
              youtube_id: contentVideoCurrent.youtube_id,
              user_source: location.state.userSource,
              next_index: e.activeIndex,
              previous_index: e.previousIndex,
              swipe_direction: e.swipeDirection,
              skus: contentVideoCurrent.skus,
            });
          }}
          onSwiper={(swiper) => setSwiper(swiper)}
        >
          {_.map(location.state.contentVideos, (contentVideo, index) => {
            return (
              <SwiperSlide
                className={classes.swiperSlide}
                key={contentVideo.id}
                virtualIndex={contentVideo.id}
              >
                <div className={classes.root}>
                  <ErrorBoundary page={"content-video-page"} section={"iframe"}>
                    <Grid
                      className={classes.closeButtonContainer}
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <IconButton
                        onClick={handleClose}
                        edge={"start"}
                        size="large"
                      >
                        <Close className={classes.ytPlayerCloseIcon} />
                      </IconButton>
                    </Grid>

                    <div className={classes.playerWrapper}>
                      {index === activeSlideIndex && (
                        <ReactVideoPlayer
                          light={true}
                          // top={"5%"}
                          height={"52%"}
                          autoplay={index === activeSlideIndex}
                          handlePlaybackStart={handlePlaybackStart}
                          handlePlaybackEnd={handlePlaybackEnd}
                          handlePlaybackProgress={handlePlaybackProgress}
                          id={youtubeIdFromRoute}
                          // videosPlaylist={videosPlaylist.slice(
                          //   videosPlaylist.indexOf(
                          //     `https://www.youtube-nocookie.com/embed/${contentVideo.youtube_id}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=${language}`
                          //   ),
                          //   videosPlaylist.length
                          // )}
                          src={`https://www.youtube-nocookie.com/embed/${
                            contentVideo.youtube_id
                          }?autoplay=${
                            index === activeSlideIndex ? 1 : 0
                          }&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=${language}`}
                        />
                      )}
                    </div>

                    <Container className={classes.videoMetadata}>
                      {contentVideoCurrent &&
                        !_.isEmpty(contentVideoCurrent) && (
                          <>
                            <Grid
                              className={classes.titleContainer}
                              container
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                            >
                              <Grid item xs={12}>
                                <Typography
                                  className={classes.contentVideoTitle}
                                >
                                  {contentVideo.title}
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid
                              className={classes.viewsContainer}
                              container
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="center"
                            >
                              <Grid item xs={12}>
                                {contentVideoCurrent.views_count &&
                                contentVideoCurrent.views_count > 24 ? (
                                  <IconButton
                                    aria-label="views"
                                    edge={"start"}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    className={classes.viewsIconContainer}
                                    size="large"
                                  >
                                    <Visibility className={classes.viewsIcon} />
                                    <Typography
                                      variant={"caption"}
                                      className={classes.viewsCount}
                                    >
                                      {contentVideoCurrent.views_count}
                                    </Typography>
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    edge={"start"}
                                    aria-label="new"
                                    className={classes.newTagContainer}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    size="large"
                                  >
                                    <Typography
                                      variant={"caption"}
                                      className={classes.newTag}
                                    >
                                      {
                                        messages[
                                          `cropPage.contentVideo.newTag`
                                        ][language]
                                      }
                                    </Typography>
                                  </IconButton>
                                )}
                              </Grid>
                            </Grid>

                            <Grid
                              className={classes.authorContainer}
                              container
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="center"
                            >
                              <Grid item xs={2}>
                                <Avatar
                                  aria-label="author"
                                  src={`${
                                    config.gcpBucketBase
                                  }content${encodeURIComponent(
                                    contentVideoCurrent.authorImage
                                  )}?alt=media`}
                                  className={classes.avatar}
                                >
                                  {contentVideoCurrent.authorName && (
                                    <>
                                      {contentVideoCurrent.authorName.charAt(0)}
                                    </>
                                  )}
                                </Avatar>
                              </Grid>
                              <Grid item xs={10}>
                                <Typography className={classes.authorName}>
                                  {
                                    messages["dashboard.live.byAuthor"][
                                      language
                                    ]
                                  }
                                  {contentVideoCurrent.authorName}
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid
                              className={classes.skusContainer}
                              container
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                            >
                              <Grid item xs={9}>
                                {" "}
                                {contentVideoCurrent.skus &&
                                  contentVideoCurrent.skus !== "" && (
                                    <>
                                      <Typography className={classes.skusTitle}>
                                        {
                                          messages[
                                            `cropPage.contentVideo.productsInTheVideo`
                                          ][language]
                                        }
                                      </Typography>
                                      <Grid
                                        className={classes.skusContainer}
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                        spacing={1}
                                      >
                                        {contentVideoCurrent.skus
                                          .slice(0, 3)
                                          .map((sku) => {
                                            return (
                                              <Grid item>
                                                <Card
                                                  className={classes.skuCard}
                                                  onClick={() => {
                                                    firebase
                                                      .analytics()
                                                      .logEvent(
                                                        "app_pdp_opened",
                                                        {
                                                          flow: "from-crop-page",
                                                          crop_name:
                                                            contentVideoCurrent
                                                              .cropData.name_en,
                                                          author_name:
                                                            contentVideoCurrent
                                                              .authorData
                                                              .name_en,
                                                          title:
                                                            contentVideoCurrent.title,
                                                          weeks_after_sowing:
                                                            contentVideoCurrent.weeks_after_sowing,
                                                          stage:
                                                            contentVideoCurrent
                                                              .stageData
                                                              .name_en,
                                                          crop_age:
                                                            contentVideoCurrent.crop_age,
                                                          state:
                                                            contentVideoCurrent
                                                              .stateData
                                                              .name_en,
                                                          position:
                                                            location.state
                                                              .position,
                                                          user_type:
                                                            location.state
                                                              .userType,
                                                          farmer_crops:
                                                            JSON.stringify(
                                                              location.state
                                                                .farmerCrops
                                                            ),
                                                          crop_segment:
                                                            contentVideoCurrent.crop_segment,
                                                          youtube_id:
                                                            contentVideoCurrent.youtube_id,
                                                          user_source:
                                                            location.state
                                                              .userSource,
                                                          skus: contentVideoCurrent.skus,
                                                        }
                                                      );
                                                    window.location.replace(
                                                      `https://agrostar.in/product/gold/${sku}?language=${language}`
                                                    );
                                                  }}
                                                >
                                                  <CardMedia
                                                    component={`img`}
                                                    className={classes.skuImage}
                                                    image={`https://static.agrostar.in/static/${sku}_1.jpg`}
                                                    onError={handleImageError}
                                                    height={45}
                                                  />
                                                  <Button
                                                    variant={"contained"}
                                                    color={"secondary"}
                                                    size={"small"}
                                                    className={
                                                      classes.skuClickHere
                                                    }
                                                    onClick={() => {
                                                      console.log("clicked");
                                                    }}
                                                  >
                                                    {
                                                      messages[
                                                        `cropPage.contentVideo.clickHereSKU`
                                                      ][language]
                                                    }
                                                  </Button>
                                                </Card>
                                              </Grid>
                                            );
                                          })}
                                      </Grid>
                                    </>
                                  )}
                              </Grid>
                              <Grid item xs={3}>
                                {location.state && location.state.mobile && (
                                  <>
                                    <Grid
                                      container
                                      spacing={0}
                                      direction="column"
                                      className={classes.socialActionContainer}
                                      justifyContent="flex-end"
                                      alignItems="flex-end"
                                    >
                                      <Grid item>
                                        <WhatsappShareButton
                                          url={`https://agrostar.onelink.me/9ngX/gold${
                                            location?.state?.userState?.code
                                              ? location?.state?.userState?.code?.toLowerCase()
                                              : `mh`
                                          }`}
                                          title={`${getShareText()}`}
                                          onClick={share}
                                          className={classes.shareIconContainer}
                                        >
                                          <img
                                            className={classes.shareIcon}
                                            src={
                                              "../../../icons/whatsApp-circle.svg"
                                            }
                                            alt="whatsapp-share"
                                          />
                                        </WhatsappShareButton>
                                      </Grid>
                                      <Grid
                                        item
                                        className={classes.sharesCountContainer}
                                      >
                                        <Typography
                                          variant={"caption"}
                                          className={classes.sharesCount}
                                        >
                                          {contentVideoCurrent.shares_count}
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        {contentVideoCurrent.likedByMe ? (
                                          <IconButton
                                            edge={"end"}
                                            aria-label="unlike"
                                            onClick={unlikeAVideo}
                                            className={classes.likeButton}
                                            size="large"
                                          >
                                            <img
                                              src={
                                                "../../../icons/liked-circle.svg"
                                              }
                                              className={classes.unlikeIcon}
                                            />{" "}
                                          </IconButton>
                                        ) : (
                                          <IconButton
                                            edge={"end"}
                                            aria-label="like"
                                            onClick={likeAVideo}
                                            className={classes.likeButton}
                                            size="large"
                                          >
                                            <img
                                              src={
                                                "../../../icons/like-circle.svg"
                                              }
                                              className={classes.likeIcon}
                                            />{" "}
                                          </IconButton>
                                        )}
                                      </Grid>
                                      <Grid
                                        item
                                        className={classes.likesCountContainer}
                                      >
                                        <Typography
                                          variant={"caption"}
                                          className={classes.likesCount}
                                        >
                                          {contentVideoCurrent.likes || ``}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                            </Grid>
                            <Grid
                              className={classes.nextButtonContainer}
                              container
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                            >
                              <Grid item xs={3} />

                              <Grid item xs={3}>
                                <Button
                                  size={"small"}
                                  variant="contained"
                                  disabled={index === 0}
                                  onClick={() => {
                                    swiper.slideTo(index - 1);
                                    firebase
                                      .analytics()
                                      .logEvent(
                                        "previous_video_button_clicked",
                                        {
                                          flow: "from-crop-page",
                                          crop_name:
                                            contentVideoCurrent.cropData
                                              .name_en,
                                          author_name:
                                            contentVideoCurrent.authorData
                                              .name_en,
                                          title: contentVideoCurrent.title,
                                          weeks_after_sowing:
                                            contentVideoCurrent.weeks_after_sowing,
                                          stage:
                                            contentVideoCurrent.stageData
                                              .name_en,
                                          crop_age:
                                            contentVideoCurrent.crop_age,
                                          state:
                                            contentVideoCurrent.stateData
                                              .name_en,
                                          position: location.state.position,
                                          user_type: location.state.userType,
                                          farmer_crops: JSON.stringify(
                                            location.state.farmerCrops
                                          ),
                                          crop_segment:
                                            contentVideoCurrent.crop_segment,
                                          youtube_id:
                                            contentVideoCurrent.youtube_id,
                                          user_source:
                                            location.state.userSource,
                                          skus: contentVideoCurrent.skus,
                                        }
                                      );
                                  }}
                                  className={classes.previousButton}
                                >
                                  <ExpandLess />
                                  {
                                    messages[
                                      `cropPage.contentVideo.previousVideo`
                                    ][language]
                                  }
                                </Button>
                              </Grid>
                              <Grid item xs={3}>
                                <Button
                                  size={"small"}
                                  variant="contained"
                                  disabled={
                                    index ===
                                    location.state.contentVideos.length - 1
                                  }
                                  onClick={() => {
                                    swiper.slideTo(index + 1);
                                    firebase
                                      .analytics()
                                      .logEvent("next_video_button_clicked", {
                                        flow: "from-crop-page",
                                        crop_name:
                                          contentVideoCurrent.cropData.name_en,
                                        author_name:
                                          contentVideoCurrent.authorData
                                            .name_en,
                                        title: contentVideoCurrent.title,
                                        weeks_after_sowing:
                                          contentVideoCurrent.weeks_after_sowing,
                                        stage:
                                          contentVideoCurrent.stageData.name_en,
                                        crop_age: contentVideoCurrent.crop_age,
                                        state:
                                          contentVideoCurrent.stateData.name_en,
                                        position: location.state.position,
                                        user_type: location.state.userType,
                                        farmer_crops: JSON.stringify(
                                          location.state.farmerCrops
                                        ),
                                        crop_segment:
                                          contentVideoCurrent.crop_segment,
                                        youtube_id:
                                          contentVideoCurrent.youtube_id,
                                        user_source: location.state.userSource,
                                        skus: contentVideoCurrent.skus,
                                      });
                                  }}
                                  className={classes.nextButton}
                                >
                                  <ExpandMore />
                                  {
                                    messages[`cropPage.contentVideo.nextVideo`][
                                      language
                                    ]
                                  }
                                </Button>
                              </Grid>
                              <Grid item xs={2} />
                            </Grid>
                          </>
                        )}
                    </Container>
                  </ErrorBoundary>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        youtubeIdFromRoute &&
        youtubeIdFromRoute !== "" && (
          <div className={classes.root}>
            <ErrorBoundary page={"content-video-page"} section={"iframe"}>
              <Grid
                className={classes.closeButtonContainer}
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <IconButton onClick={handleClose} edge={"start"} size="large">
                  <Close className={classes.ytPlayerCloseIcon} />
                </IconButton>
              </Grid>

              <div className={classes.playerWrapper}>
                <ReactVideoPlayer
                  light={true}
                  // top={"5%"}
                  height={"52%"}
                  autoplay={true}
                  handlePlaybackStart={handlePlaybackStart}
                  handlePlaybackEnd={handlePlaybackEnd}
                  handlePlaybackProgress={handlePlaybackProgress}
                  id={youtubeIdFromRoute}
                  src={`https://www.youtube-nocookie.com/embed/${youtubeIdFromRoute}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=${language}`}
                />
              </div>

              <Container className={classes.videoMetadataShared}>
                {contentVideoCurrent && !_.isEmpty(contentVideoCurrent) && (
                  <>
                    <Grid
                      className={classes.titleContainer}
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                    >
                      <Grid item xs={12}>
                        <Typography className={classes.contentVideoTitle}>
                          {contentVideoCurrent.title}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      className={classes.viewsContainer}
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        {contentVideoCurrent.views_count &&
                        contentVideoCurrent.views_count > 24 ? (
                          <IconButton
                            aria-label="views"
                            edge={"start"}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            className={classes.viewsIconContainer}
                            size="large"
                          >
                            <Visibility className={classes.viewsIcon} />
                            <Typography
                              variant={"caption"}
                              className={classes.viewsCount}
                            >
                              {contentVideoCurrent.views_count}
                            </Typography>
                          </IconButton>
                        ) : (
                          <IconButton
                            edge={"start"}
                            aria-label="new"
                            className={classes.newTagContainer}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            size="large"
                          >
                            <Typography
                              variant={"caption"}
                              className={classes.newTag}
                            >
                              {
                                messages[`cropPage.contentVideo.newTag`][
                                  language
                                ]
                              }
                            </Typography>
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>

                    <Grid
                      className={classes.authorContainer}
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={2}>
                        <Avatar
                          aria-label="author"
                          src={`${
                            config.gcpBucketBase
                          }content${encodeURIComponent(
                            contentVideoCurrent.authorImage
                          )}?alt=media`}
                          className={classes.avatar}
                        >
                          {contentVideoCurrent.authorName && (
                            <>{contentVideoCurrent.authorName.charAt(0)}</>
                          )}
                        </Avatar>
                      </Grid>
                      <Grid item xs={10}>
                        <Typography className={classes.authorName}>
                          {messages["dashboard.live.byAuthor"][language]}
                          {contentVideoCurrent.authorName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Container>
            </ErrorBoundary>
          </div>
        )
      )}
    </>
  );
}

export default YoutubeDialog;
